// TODO: convert to .ts file and fix codestyle\typing issues
import Vue from 'vue'

import Main from './main.vue'
const NotificationConstructor = Vue.extend(Main)

let instance
const instances = []
let seed = 1

const Notification = (options) => {
  if (Vue.prototype.$isServer) {
    return
  }
  options = options || {}
  const userOnClose = options.onClose
  const id = 'notification_' + (seed++).toString()
  const position = options.position || 'top-right'

  options.onClose = () => {
    Notification.close(id, userOnClose)
  }

  instance = new NotificationConstructor({
    data: options,
  })

  instance.id = id
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  instance.dom.style.zIndex = 9001

  const gap = options.offset || 0
  let verticalOffset = gap
  instances
    .filter((item) => item.position === position)
    .forEach((item) => {
      verticalOffset += item.$el.offsetHeight + gap
    })
  verticalOffset += gap
  instance.verticalOffset = verticalOffset
  instances.push(instance)
  return instance.vm
}

;['success', 'warning', 'info', 'error'].forEach((type) => {
  Notification[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options,
      }
    }
    options.type = type
    return Notification(options)
  }
})

Notification.close = function(id, userOnClose) {
  let index = -1
  const len = instances.length
  const instance = instances.filter((ins, i) => {
    if (ins.id === id) {
      index = i
      return true
    }
    return false
  })[0]
  if (!instance) {
    return
  }

  if (typeof userOnClose === 'function') {
    userOnClose(instance)
  }
  instances.splice(index, 1)

  if (len <= 1) {
    return
  }
  const position = instance.position
  const removedHeight = instance.dom.offsetHeight
  const gap = instance.offset || 0
  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] =
        parseInt(instances[i].dom.style[instance.verticalProperty], 10) -
        removedHeight -
        gap +
        'px'
    }
  }
}

Notification.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close()
  }
}

export default Notification
